import { render, staticRenderFns } from "./DocumentLine.vue?vue&type=template&id=278840ba&scoped=true&"
import script from "./DocumentLine.vue?vue&type=script&lang=js&"
export * from "./DocumentLine.vue?vue&type=script&lang=js&"
import style0 from "./DocumentLine.vue?vue&type=style&index=0&id=278840ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278840ba",
  null
  
)

export default component.exports